import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button } from '@cian/ui-kit/button';
import { Spinner } from '@cian/ui-kit/loader';
import * as React from 'react';
import { requestUndergroundMapData } from '../../services/requestUndergroundMapData';
import { isUndergroundMapV2 } from '../../utils/isUndergroundMapV2';
import { UndergroundMapV1 } from './UndergroundMapV1';
import { UndergroundMapV2 } from './UndergroundMapV2';
export var UndergroundMap = function UndergroundMap(_ref) {
  var locationId = _ref.locationId,
      selectedStations = _ref.selectedStations,
      onDataRequested = _ref.onDataRequested,
      onSelect = _ref.onSelect,
      onRemove = _ref.onRemove,
      apiRef = _ref.apiRef;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mapData = _React$useState2[0],
      setMapData = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasError = _React$useState4[0],
      setHasError = _React$useState4[1];

  var requestData = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locationId) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasError(false);
              _context.prev = 1;
              _context.next = 4;
              return requestUndergroundMapData(locationId, onDataRequested);

            case 4:
              data = _context.sent;
              setMapData(data);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              setHasError(true);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onDataRequested]);

  var handleRetry = function handleRetry() {
    requestData(locationId);
  };

  React.useEffect(function () {
    requestData(locationId);
  }, [locationId, requestData]);

  if (hasError) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "error-msg"
    }, "\u0412\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u0432\u043E\u0451 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437.", /*#__PURE__*/React.createElement(Button, {
      "data-testid": "error-retry",
      onClick: handleRetry
    }, "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C"));
  }

  if (!mapData) {
    return /*#__PURE__*/React.createElement(Spinner, {
      "data-testid": "spinner",
      size: 42
    });
  }

  if (isUndergroundMapV2(mapData)) {
    return /*#__PURE__*/React.createElement(UndergroundMapV2, {
      apiRef: apiRef,
      data: mapData,
      selectedStations: selectedStations,
      onSelect: onSelect,
      onRemove: onRemove
    });
  }

  return /*#__PURE__*/React.createElement(UndergroundMapV1, {
    apiRef: apiRef,
    data: mapData,
    selectedStations: selectedStations,
    onSelect: onSelect,
    onRemove: onRemove
  });
};